import { NumberInput, NumberInputProps } from '@mantine/core'
import React from 'react'
import QuizTooltip from '../../quiz/QuizTooltip'
interface ICustomNumberInput extends NumberInputProps {
    tooltip?: string
}
const CustomNumberInput = ({
    tooltip,
    hideControls = true,
    placeholder = '0',
    ...other
}: ICustomNumberInput) => {
    if (tooltip) {
        return (
            <QuizTooltip label={tooltip}>
                <NumberInput
                    w={200}
                    hideControls={hideControls}
                    placeholder={placeholder}
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                            textAlign: 'end',
                        },
                    }}
                    {...other}
                />
            </QuizTooltip>
        )
    }
    return (
        <NumberInput
            w={200}
            hideControls={hideControls}
            placeholder={placeholder}
            styles={{
                input: {
                    borderColor: 'var(--mantine-color-gray-2)',
                    textAlign: 'end',
                },
            }}
            {...other}
        />
    )
}

export default CustomNumberInput
